module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-03.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-03.png
// module id = 1399
// module chunks = 0